import { AesMidasApi } from '@orbis-systems/orbis-api-clients/aesmidas';
import { BridgeWiseApi } from '@orbis-systems/orbis-api-clients/bridgewise';
import { InsightApi } from '@orbis-systems/orbis-api-clients/insight';
import { MiddlewareApi } from '@orbis-systems/orbis-api-clients/middleware';
import { OrbisApi } from '@orbis-systems/orbis-api-clients/orbis';
import { UmaApi } from '@orbis-systems/orbis-api-clients/uma';

export * from './Account.type';
export * from './Amo.type';
export * from './Branch.type';
export * from './CorporateAction.type';
export * from './Document.type';
export * from './DriftReport.type';
export * from './Group.type';
export * from './Market.type';
export * from './Model.type';
export * from './News.type';
export * from './Order.type';
export * from './Portfolio.type';
export * from './Quote.type';
export * from './Research.type';
export * from './Stat.type';
export * from './Tipranks.type';
export * from './Trading.type';
export * from './User.type';
export * from './Watchlist.type';

export enum CacheLevel {
    NoCache,
    RequestsOnly,
    RequestsAndCalculations,
}

export interface ApiPermissions {
    advisor: boolean;
    rtbs: boolean;
    iav: boolean;
    documents: boolean;
    transfers: boolean;
    iavProcessorToken: boolean;
}

export enum ApiVariant {
    Orbis,
}

export interface MiddlewareConfig<T extends ApiVariant = ApiVariant.Orbis> {
    apiVariant?: T;
    websocketUrl?: string;
    cacheDuration: number;
    cacheLevel: CacheLevel;
    useAes: boolean;
    useMiddlewareAmo: boolean;
    apiPermissions: ApiPermissions;
}

export interface Apis {
    orbis: OrbisApi;
    middleware: MiddlewareApi;
    insight: InsightApi;
    bridgeWise: BridgeWiseApi;
    uma?: UmaApi;
    aesMidas?: AesMidasApi;
}

export type BranchInfo = {
    balance: number;
    cash: number;
    portfolioValue: number;
    monthlyCashflow: number;
    totalModels: number;
    totalAccounts: number;
    totalGroups: number;
};

export type HoldingInfo = {
    totalValue: number;
    totalCostValue: number;
    gainPercent: number;
    price: number;
    totalHolding: number;
    positionWeight: number;
    modelTarget: number;
    currency?: string;
};

export type Rtbs = {
    balance: number;
    totalDividendAmount: number;
    totalDividendYield: number;
    sodCashBalance: number;
    sodMarginBalance: number;
    sodShortBalance: number;
    cashOnAccount: number;
    markToMarket: number;
};

export type GroupRtbs = Rtbs & { accountId: number; modelId: number };

export type PaginationData<T> = {
    data: T[];
    totalCount: number;
};
